import { getEmployerCompensationDailyBase } from '../LegalParameters/EmployerCompensationDailyBase';
import { getSocialInsuranceDailyBase } from '../LegalParameters/SocialInsuranceDailyBase';

export function round2(number) {
	return Math.round(number * 100) / 100;
}

export default ({ dailyBase, pay_hour, hours, days, year }) => {
	const reducedBase = getSocialInsuranceDailyBase({
		income: dailyBase,
		year,
	});
	const low = Math.ceil(0.6 * reducedBase);
	const mid = Math.ceil(0.66 * reducedBase);
	const high = Math.ceil(0.72 * reducedBase);
	let total = 0;

	if (days > 14) {
		total += (Math.min(days, 30) - 14) * low;
	}
	if (days > 30) {
		total += (Math.min(days, 60) - 30) * mid;
	}
	if (days > 60) {
		total += (days - 60) * high;
	}

	const employerCompensation = getEmployerCompensationDailyBase({
		income: pay_hour * 8,
		year,
	});
	const employer = employerCompensation * (hours / 8);

	return { total, low, mid, high, employer, days, hours };
};
